{
  "pages": {
    "listTitle": "Nhật ký hệ thống",
    "permissionDenied": "Bạn không có quyền xem nhật ký hệ thống.",
    "detailsTitle": "Chi tiết nhật ký",
    "closeDetails": "Đóng chi tiết nhật ký"
  },
  "fields": {
    "time": "Thời gian",
    "action": "Hành động",
    "actor": "Người thực hiện",
    "entity": "Đối tượng",
    "severity": "Mức độ",
    "outcome": "Kết quả",
    "summary": "Tóm tắt",
    "related": "Liên quan",
    "module": "Module"
  },
  "filters": {
    "trigger": "Bộ lọc",
    "title": "Lọc nhật ký hệ thống",
    "reset": "Xóa lọc",
    "apply": "Áp dụng",
    "dateRange": "Khoảng thời gian",
    "dateRangePlaceholder": "Chọn khoảng ngày",
    "selectModule": "Chọn module",
    "selectSeverity": "Chọn mức độ",
    "selectOutcome": "Chọn kết quả",
    "allModules": "Tất cả module",
    "allSeverities": "Tất cả mức độ",
    "allOutcomes": "Tất cả kết quả"
  },
  "search": {
    "placeholder": "Tìm theo hành động hoặc tóm tắt..."
  },
  "table": {
    "empty": "Không có nhật ký nào.",
    "emptySearch": "Không tìm thấy nhật ký phù hợp."
  },
  "activity": {
    "title": "Hoạt động",
    "empty": "Chưa có hoạt động nào được ghi nhận.",
    "yesterday": "Hôm qua",
    "unknownDay": "Không rõ ngày",
    "loadMore": "Xem thêm"
  },
  "details": {
    "changes": "Thay đổi",
    "data": "Dữ liệu",
    "metadata": "Thông tin bổ sung"
  },
  "modules": {
    "patient": "Bệnh nhân",
    "appointment": "Lịch hẹn",
    "payment": "Thanh toán",
    "staff": "Nhân sự",
    "scheduling": "Xếp ca",
    "identity": "Danh tính",
    "clinic": "Phòng khám"
  },
  "severity": {
    "info": "Thông tin",
    "warning": "Cảnh báo",
    "critical": "Nghiêm trọng"
  },
  "outcome": {
    "success": "Thành công",
    "failure": "Thất bại"
  },
  "toasts": {
    "loadListFailed": "Không tải được nhật ký hệ thống",
    "loadListFailedWithRetry": "Không tải được nhật ký hệ thống. Vui lòng thử lại.",
    "loadDetailsFailed": "Không tải được chi tiết nhật ký.",
    "loadActivityFailed": "Không tải được lịch sử hoạt động."
  },
  "pagination": {
    "rowsPerPage": "Số dòng mỗi trang:",
    "rowsPerPageShort": "Số dòng:",
    "displayedRows": "{{from}}–{{to}} / {{count}}",
    "moreThan": "hơn {{to}}"
  }
}
